import MuiDialog from '@mui/material/Dialog';
import MuiPaper from '@mui/material/Paper';
import styled from 'styled-components';
import Container from '../Container';
import Icon from '../Icon';
import Typography from '../Typography';
export const ModalPaper = styled(MuiPaper)(({ theme, }) => ({
    width: '100%',
    maxWidth: '800px',
    boxShadow: '0px 2px 4px rgba(51, 51, 51, 0.08)',
    borderRadius: '20px',
    justifyContent: 'space-between',
    minHeight: '200px',
}));
const getSizes = (breakpoints, multiplier) => (Object.entries(breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.values).reduce((reducer, [k, v]) => ({
    ...reducer,
    [breakpoints.up(k)]: {
        maxWidth: `${multiplier * v}px`,
    },
}), // eslint-disable-next-line indent
{}));
export const ModalStyled = styled(MuiDialog).attrs({
    PaperComponent: ModalPaper,
})(({ theme, size = 'medium', }) => ({
    ...[{ display: 'none' }],
    [`${ModalPaper}`]: {
        ...size && {
            small: {
                maxHeight: '40%',
                ...getSizes(theme === null || theme === void 0 ? void 0 : theme.breakpoints, 0.5),
            },
            medium: {
                maxHeight: '55%',
                ...getSizes(theme === null || theme === void 0 ? void 0 : theme.breakpoints, 0.6),
            },
            large: {
                maxHeight: '70%',
                ...getSizes(theme === null || theme === void 0 ? void 0 : theme.breakpoints, 0.7),
            },
            fullwidth: {
                maxHeight: '90%',
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                maxWidth: 'unset',
                margin: 0,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
            },
            fullscreen: {
                position: 'fixed',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                maxHeight: 'unset',
                maxWidth: 'unset',
                margin: 0,
                borderRadius: 0,
            },
        }[size],
        [theme === null || theme === void 0 ? void 0 : theme.breakpoints.only('mobile')]: {
            margin: '0px !important',
            maxHeight: '80vh',
            maxWidth: '100vw',
            width: '100vw',
            alignSelf: 'flex-end',
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
        },
    },
    [theme === null || theme === void 0 ? void 0 : theme.breakpoints.only('mobile')]: {
        padding: '0px',
    },
}));
export const ModalHeadline = styled(Typography).attrs({
    variant: 'subtitle2',
})(({ theme, }) => ({
    marginBottom: '10px',
    [theme === null || theme === void 0 ? void 0 : theme.breakpoints.only('mobile')]: {
        marginBottom: '8px',
    },
}));
export const ModalContent = styled(Container)(({ theme, }) => ({
    flexShrink: 1,
    flexGrow: 1,
    overflow: 'auto',
    padding: '48px 32px 0px',
    ':last-child': {
        paddingBottom: '32px',
    },
    [theme === null || theme === void 0 ? void 0 : theme.breakpoints.only('mobile')]: {
        padding: '40px 24px 0px',
        ':last-child': {
            paddingBottom: '24px',
        },
    },
}));
export const ModalBody = styled(Container)(({ theme, }) => ({}));
export const ModalButtons = styled(Container)(({ theme, justifyButtons = 'center', }) => ({
    display: 'flex',
    justifyContent: justifyButtons,
    gap: '16px',
    padding: '20px 32px 32px',
    lineBreak: 'anywhere',
    flexWrap: 'wrap',
    [theme === null || theme === void 0 ? void 0 : theme.breakpoints.only('mobile')]: {
        gap: '8px',
        padding: '12px 24px 24px',
    },
}));
export const ModalClose = styled(Icon).attrs({
    name: 'x',
    size: 'l',
})(({ theme, onClick, }) => ({
    display: 'block',
    position: 'absolute',
    height: '0px',
    zIndex: 1,
    top: '24px',
    right: '24px',
    svg: {
        height: '32px',
        width: 'unset',
    },
    [theme === null || theme === void 0 ? void 0 : theme.breakpoints.only('mobile')]: {
        top: '16px',
        right: '16px',
        svg: {
            height: '24px',
        },
    },
    ...(!onClick && {
        '> *': {
            display: 'none',
        },
    }),
}));
//# sourceMappingURL=Modal.styles.js.map